import { graphql } from 'gatsby';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Footer } from '../components/Footer';
import { Nav } from '../components/Nav';
import { Main } from '../components/Main';
import GlobalContext from '../components/GlobalContext';

const StyledMain = styled.main`
  width: 100%;
  height: 100%;
`;

interface IndexProps {
  data: any;
  chapters: any;
}

const initialState = {
  chapters: [],
  activeChapter: {},
  mainData: {},
  scrollY: 0,
};

// markup
const IndexPage: React.FC<IndexProps> = ({ data }) => {
  const [globalState, setGlobalState] = React.useContext(GlobalContext);

  const { edges } = data.chapters;
  const { footer } = data;

  useEffect(() => {
    setGlobalState({
      ...globalState,
      mainData: data.data,
      activeChapter: data.data,
      chapters: edges,
    });
  }, []);

  const mainRef = useRef<null | HTMLDivElement>(null);

  const chapterRefs = React.useMemo(
    () =>
      Array(edges.length)
        .fill(null)
        .map(() => React.createRef()),
    [edges]
  );

  return (
    <StyledMain>
      <Nav
        globalState={globalState}
        setGlobalState={setGlobalState}
        chapters={edges}
        chapterRefs={chapterRefs}
        mainRef={mainRef}
        activeChapter={globalState.activeChapter}
      />
      <Main data={data} mainRef={mainRef} chapterRefs={chapterRefs} />
      <Footer data={footer} />
    </StyledMain>
  );
};

export default IndexPage;

export const query = graphql`
  {
    data: sanityMain {
      id
      title
      secondTitle
      opacity
      pdf {
        asset {
          url
        }
      }
      backgroundImage {
        asset {
          url
        }
      }
      prefaceTitle
      _rawPrefaceContent
      _rawMainContent
      _rawSummaryGreyContentAfterDivider
      _rawSummaryGreyContent
      _rawSummaryAfterGreyContent
      summaryTitle
      summaryImage {
        asset {
          url
        }
      }
      _rawSummaryAfterImage
      imageTwo {
        asset {
          url
        }
      }
      imageThree {
        asset {
          url
        }
      }
      imageFour {
        asset {
          url
        }
      }

      _rawTextTwo
      _rawTextThree
      _rawTextFour
    }
    chapters: allSanityChapter(sort: { fields: order }) {
      edges {
        node {
          id
          _createdAt
          backgroundImage {
            asset {
              url
            }
          }
          slug {
            current
          }
          title
          opacity
          _rawText
          chapterSections {
            title
            _rawTopText
            _rawTextThree
            _rawTextFour
            _rawTextFive
            _rawBottomText
            image {
              asset {
                url
              }
            }
            imageTwo {
              asset {
                url
              }
            }
            imageThree {
              asset {
                url
              }
            }
            imageFour {
              asset {
                url
              }
            }
            imageFive {
              asset {
                url
              }
            }
          }
        }
      }
    }
    footer: sanityFooter {
      title
      id
      _rawText
      sideSections {
        _rawBottomText
        _rawTopText
        title
      }
    }
  }
`;
